import { setSPV2RedirectUrl } from "."
import {
  STUDY_PLAN_V2_OVERALL_TARGETS_BY_ROLE,
  STUDY_PLAN_V2_SUBJECT_TARGETS_BY_ROLE
} from "../../../../study-plans/pages/StudyPlansV2/constants"
import { Context, StudyPlanTargets, Transitions } from "../../types"

export const checkSPV2CurrentTargetAction = (
  ctx: Context,
  event: Transitions
): Partial<Context> => {
  if (!ctx.currentTarget) {
    if (!!ctx.subject) {
      return setSPV2RedirectUrl(
        ctx,
        event,
        { action: { action: "replace" } },
        StudyPlanTargets.ProgressByContent
      )
    }

    return setSPV2RedirectUrl(
      ctx,
      event,
      { action: { action: "replace" } },
      StudyPlanTargets.Progress
    )
  }

  if (!!ctx.subject) {
    if (
      STUDY_PLAN_V2_SUBJECT_TARGETS_BY_ROLE[ctx.user.role].includes(
        ctx.currentTarget as StudyPlanTargets
      )
    ) {
      return {}
    }

    if (
      [StudyPlanTargets.Edit, StudyPlanTargets.ViewRecommended].includes(
        ctx.currentTarget as StudyPlanTargets
      )
    ) {
      return setSPV2RedirectUrl(
        ctx,
        event,
        { action: { action: "replace" } },
        StudyPlanTargets.ManageStudyPlans
      )
    }

    return setSPV2RedirectUrl(
      ctx,
      event,
      { action: { action: "replace" } },
      StudyPlanTargets.ProgressByContent
    )
  }

  if (
    STUDY_PLAN_V2_OVERALL_TARGETS_BY_ROLE[ctx.user.role].includes(
      ctx.currentTarget as StudyPlanTargets
    )
  ) {
    return {}
  }

  return setSPV2RedirectUrl(
    ctx,
    event,
    { action: { action: "replace" } },
    StudyPlanTargets.Progress
  )
}
